<template>

  <div class="container-fluid py-3 px-4">

    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-card-text display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            REGISTRO
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            PROCESO DE RENOVACION
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-12">

      <button class="btn btn-secondary mt-2 ms-2" @click="CargaTrabajadores"
        title="Opción para cargar trabajadores que pasarán por una nueva renovación">
        <i class="bi bi-database-fill-up"></i>
      </button>

      <!-- <button class="btn btn-danger mt-2 ms-2"
        title="Opción para desbloquear el listado de trabajadores cuando ya se esta realizando una renovación INDIVIDUAL"
        @click="Indi">
        <i class="bi bi-unlock-fill"></i>
      </button> -->

      <!-- <button class="btn btn-success mt-2 ms-2" title="Opción para ir a renovación MASIVA de trabajadores"
        @click="$router.push('/RegistroRenovacionesMasiva');">
        <i class="bi bi-people"></i>
      </button> -->

      <button @click="descargarExcel" :class="{
        'btn btn-success mt-2 ms-2':
          !excelCarga,
        'btn btn-outline-success mt-2 ms-2':
          excelCarga,
      }" :disabled="!excelCarga">
        <i class="bi bi-filetype-xls"></i>
        <b v-if="excelCarga"></b>
        <b v-else>CARGANDO...</b>
      </button>

        <button class="btn btn-info text-white mt-2 ms-2" title="Borrar Filtros"
        @click="Dni = ''; Apellidos = ''; SubSubCentro = ''; Ciudad = ''">
        <i class="bi bi-eraser"></i>     
        </button> 
    </div>


    <div class="mt-2 pb-2">
      <div class="border border-1 rounded-3 p-3 mb-3 ">
        <div class="row gy-2 gx-2">

          <div class="col-lg-3 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person-vcard fs-6 text-danger"></i> DOC INDENTIDAD:</label>
            <b-input class="p-2 my-0" :disabled="Apellidos.length > 0 || SubSubCentro.length > 0 || Ciudad.length > 0"
              id="searchInput1" v-model.trim="Dni" placeholder="BUSQ. POR DOC. IDENTIDAD"
              @input="Dni = Dni.replace(/\s+/g, '');" @keydown.space.prevent></b-input>
          </div>
          <div class="col-lg-3 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person fs-6 text-success fs-6 "></i> APELLIDOS:</label>
            <b-input class="p-2 my-0" :disabled="Dni.length > 0 || SubSubCentro.length > 0 || Ciudad.length > 0"
              id="searchInput2" v-model.trim="Apellidos" placeholder="BUSQ. POR APELLIDOS"
              @input="Apellidos = Apellidos.replace(/^\s+/, '');"
              @keydown.space="Apellidos.length === 0 && $event.preventDefault()"></b-input>
          </div>
          <div class="col-lg-3 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person-video fs-6 text-warning"></i> CANAL:</label>
            <b-input class="p-2 my-0" :disabled="Dni.length > 0 || Apellidos.length > 0 || Ciudad.length > 0"
              id="searchInput2" v-model="SubSubCentro" placeholder="BUSQ. POR CANAL"
              @input="SubSubCentro = SubSubCentro.replace(/^\s+/, '');"
              @keydown.space="SubSubCentro.length === 0 && $event.preventDefault()"></b-input>
          </div>
          <div class="col-lg-3 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-geo fs-6 text-primary"></i> CIUDAD:</label>
            <b-input class="p-2 my-0" :disabled="Dni.length > 0 || Apellidos.length > 0 || SubSubCentro.length > 0"
              id="searchInput2" v-model="Ciudad" placeholder="BUSQ. POR CIUDAD"
              @input="Ciudad = Ciudad.replace(/^\s+/, '');"
              @keydown.space="Ciudad.length === 0 && $event.preventDefault()"></b-input>
          </div>
        </div>
      </div>
    </div>

    <div class="border border-1 rounded-3 p-3 mb-3">


      <!-- PANEL DE EDICIÓN MASIVA -->
      <div class="col-md-12 mt-3" v-if="esMasivo">
        <div class="border border-1 rounded-3 overflow-hidden shadow-sm mb-3">
          <div class="bg-solimano text-white px-1 d-flex align-items-center">
            <i class="bi bi-pencil-square me-1 my-auto fs-5"></i>
            <h5 class="mb-0 fw-bold tamaño text-white">EDICIÓN MASIVA ({{ seleccionadosMasivo.length }} SELECCIONADOS)
            </h5>
          </div>
          <div class="py-3 px-3 bg-light">
            <div class="row g-4 align-items-end">

              <div class="col-md-2">
                <label class="form-label fw-bold text-primary tamaño">FECHA FIN:</label>
                <input type="date" v-model="fechaFinMasivo" class="form-control p-1 text-center tamaño" />
              </div>
              <div class="col-md-3">
                <label class="form-label fw-bold text-primary tamaño">MOTIVO:</label>
                <div>
                  <select v-model="codRenMotivoMasivo" class="form-select w-100 p-1 text-center tamaño">
                    <option value="" disabled selected>-- SELECCIONAR --</option>
                    <option v-for="m in motivo" :key="m.id" :value="m.parCorrelativo">{{ m.parDescripcion }}</option>
                  </select>
                </div>
              </div>
              <div class=" d-flex col-md-2">
                <button
                  class="btn btn-outline-success btn-sm rounded-3 d-flex align-items-center justify-content-center px-2 py-1"
                  @click="CargaMasiva">
                  <i class="bi bi-check-circle-fill text-suceess fs-5"></i></button>
                  <!-- @click="Eliminar(itema.idRenovacion)" -->
                  <button 
                    class="ms-2 btn btn-outline-danger btn-sm rounded-3 d-flex align-items-center justify-content-center px-2 py-1"
                    title="Eliminar renovación">
                    <i class="bi bi-trash3 fs-5"></i>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>




    
      <div class="d-flex justify-content-end mt-3 mx-2 gap-2">
        <!-- Cuadro de Alerta de Antigüedad -->
        <div v-if="cantidadMayor5Anios > 0"
          class="d-flex align-items-center px-3 py-2 bg-danger bg-opacity-10 border border-danger rounded-3 shadow-sm">
          <i class="bi bi-exclamation-triangle-fill text-danger fs-5 me-2"></i>
          <span class="fw-bold text-danger">
            Trabajadores con 5 años o más: {{ cantidadMayor5Anios }}
          </span>
        </div>

         <div
          class="d-flex align-items-center px-3 py-2 bg-primary bg-opacity-10 border border-primary rounded-3 shadow-sm">
          <i class="bi bi-people-fill text-primary fs-5 me-2"></i>
          <span class="fw-bold text-primary">
            {{ Dni.length > 0 ? 'Total por DNI' :
              Apellidos.length > 0 ? 'Total por Apellidos' :
                SubSubCentro.length > 0 ? 'Total por Canal' :
                  Ciudad.length > 0 ? 'Total por Ciudad' :
                    'Trabajadores' }}: {{ itemsFiltrados.length }}
          </span>
        </div>
        <div
          class=" ms-1 d-flex align-items-center px-3 py-2 bg-danger bg-opacity-10 border border-danger rounded-3 shadow-sm">
          <i class="bi bi-vector-pen text-danger fs-5 me-2"></i>
          <span class="fw-bold text-danger">
            Renovaciones Pendientes : {{ Items.length }}
          </span>
        </div>
      </div>

      <!-- Resumen agrupado: Empresa - Canal (Cantidad) -->
      <div class="d-flex justify-content-end flex-wrap gap-2 mt-2 mx-2">
        <div v-for="(grupo, i) in resumenGrupos" :key="i"
          class="d-flex align-items-center px-3 py-2 bg-info bg-opacity-10 border border-info rounded-3 shadow-sm">
          <i class="bi bi-building-gear text-info fs-6 me-2"></i>
          <span class="fw-bold text-info small text-uppercase">
            {{ grupo.nombre }}: {{ grupo.cantidad }}
          </span>
        </div>
      </div>

      <div class="table-responsive mx-2 mt-2 border border-1 rounded-3 shadow-sm">
        <table v-if="primeraTabla" class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-center text-white text-nowrap">
              <th :colspan="esMasivo ? 5 : 5">DATOS GENERALES</th>
              <!-- Ocultamos cabecera de grupo RENOVACION si es masivo -->
              <th :colspan="esMasivo ? 2 : 4">RENOVACION</th>
              <th colspan="3">HISTORIAL</th>
            </tr>
            <tr class="bg-solimano text-center text-white text-nowrap">
              <th scope="col">
                <div @click="MarcarTodos()"
                  :class="seleccionadosMasivo.length > 0 ? 'bg-dark border-white' : 'bg-white border-white'"
                  style="cursor: pointer; width: 12px; height: 12px; border: 1px solid; display: inline-block; border-radius: 2px; transition: 0.2s;">
                </div>
              </th>
              <th scope="col">PERIODO</th>
              <!-- <th scope="col">CIUDAD</th> -->
              <th scope="col">TRABAJADOR</th>
              <th scope="col">CLIENTE</th>
              <th scope="col">CONTRATO ACTUAL</th>
              <!-- <th scope="col">SUELDO</th> -->
              <th scope="col">FECHA INICIO</th>
              <th scope="col" v-if="!esMasivo">FECHA FIN</th>
              <th scope="col" v-if="!esMasivo">MOTIVO</th>
              <th scope="col">VCTO. DE CONTRATO</th>
              <th scope="col">RECORD TRABAJADORES</th>
              <th scope="col"><i class="bi bi-boxes"></i></th>
            </tr>
          </thead>

          <tbody class="align-middle">
            <tr class="text-center align-middle reducirTamaño" v-for="(itema, index) in itemsPaginados" :key="index">
              <td class="px-2" scope="row">
                <div class="">
                  <input @change="actualizarEstado(itema)" type="checkbox" :value="itema.idRenovacion"
                    v-model="itema.renAccionReg" />
                </div>
              </td>

              <!-- PERIODO + ESTADO -->
              <td class="text-start fw-bold">
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-calendar3 text-secondary fs-7"></i>
                  <label>{{ itema.periodo }}</label>
                </div>

                <div class="d-flex align-items-center gap-2 mt-1">
                  <i :class="{
                    ' bi bi-arrow-clockwise text-primary': itema.renCodEstado == 'EN PROCESO',
                    'bi bi-check-circle-fill text-warning': itema.renCodEstado == 'SOLICITADO',
                    'bi bi-x-circle-fill text-danger': itema.renCodEstado == 'NO RENOVADO',
                  }"></i>
                  <label :class="{
                    'text-primary': itema.renCodEstado == 'EN PROCESO',
                    'text-warning': itema.renCodEstado == 'SOLICITADO',
                    'text-danger': itema.renCodEstado == 'NO RENOVADO',
                  }">
                    {{ itema.renCodEstado }}
                  </label>
                </div>
              </td>

              <!-- DEPARTAMENTO -->
              <!-- <td class="text-start ">
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-buildings text-info fs-6"></i>
                  <label>{{ itema.departamento }}</label>
                </div>
              </td> -->

              <!-- DOCUMENTO + NOMBRE -->
              <td class="text-start ">


                <div class="d-flex align-items-center gap-2 fw-bold">
                  <i class="bi bi-buildings text-info fs-6"></i>
                  <label>{{ itema.departamento }}</label>
                </div>

                <div class="d-flex align-items-center gap-2 fw-bold">
                  <i class="bi bi-credit-card-2-front text-success fs-6"></i>
                  <label>{{ itema.nroDocumento }}</label>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-person-circle text-primary fs-6"></i>
                  <label>{{ itema.nomTrabajador }}</label>
                </div>
              </td>


              <td class="text-start">
                <!-- <select
                        @change="SubSubCentroCostosManda($event)"
                        v-if="itema.accionRen"
                        class="form-control text-center"
                        id="exampleFormControlSelect1"
                        disabled
                        >
                        <option disabled selected>
                            {{ itema.subSubCentroCostos }}
                        </option>
                        <option
                            v-for="subSubCentro in SubSubCentroCosto"
                            :key="subSubCentro.id"
                            :value="subSubCentro.cenSubSubCodigo"
                        >
                            {{ subSubCentro.cenNombre }}
                        </option>
                        </select> -->

                <div class="d-flex align-items-center gap-2 fw-bold">
                  <i class="bi bi-building fs-6 "></i>
                  <label>{{ itema.nomEmpresa }}</label><br>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-diagram-2-fill fs-6 text-danger"></i>
                  <label>{{ itema.subCentroCostos }}</label><br>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-diagram-3-fill fs-6 text-info"></i>
                  <label> {{ itema.subSubCentroCostos }}</label>
                </div>
              </td>



              <td class="px-1 mx-0 ">
                <div class="d-flex flex-column align-items-center fw-bold text-center">

                  <!-- Fechas de contrato -->


                  <div class="d-flex align-items-center gap-2">

                    <i class="bi bi-calendar3 text-warning fs-6"></i>
                    <span v-if="itema.fecIniConActual.slice(0, 10) === '1900-01-01'">-</span>
                    <span v-else>
                      {{ new Date(itema.fecIniConActual).toLocaleDateString('es-ES') }}
                      -
                      {{ new Date(itema.fecFinConActual).toLocaleDateString('es-ES') }}
                    </span>
                  </div>

                  <div class="d-flex align-items-center gap-2">
                    <i class="bi bi-briefcase-fill fs-6 text-primary"></i>
                    <label>{{ itema.nomPuesto }}</label>
                  </div>

                  <!-- Sueldo actual -->
                  <div class="d-flex align-items-center gap-2">
                    <i class="bi bi-cash-stack text-success fs-6"></i>
                    <span>SUELDO ACTUAL: {{ itema.renSueldoActual }}</span>
                  </div>
                </div>
              </td>

              <!-- SUELDO -->
              <!-- <td class="align-middle text-center">
                <div class="form-group">
                  <p v-if="
                    sueldoFinal >
                    itema.renSueldoActual * (sueldoCargo / 100) +
                    itema.renSueldoActual &&
                    from.idRenovacion == itema.idRenovacion
                  " class="text-danger small fw-semibold mb-1">
                    <i class="bi bi-exclamation-triangle-fill  fs-7"></i>
                    No puedes exceder el 20% del sueldo actual:
                    <span class="text-dark">
                      {{
                        (
                          parseFloat(itema.renSueldoActual) * (1 + sueldoCargo / 100)
                        ).toFixed(2)
                      }}
                    </span>
                  </p> -->

              <!-- Campo editable / lectura -->
              <!-- <div class="d-flex justify-content-center align-items-center gap-2"> -->
              <!-- <i class="bi bi-cash-stack text-success fs-6"></i> -->
              <!-- <input v-if="itema.accionRen" type="text" class="form-control form-control-sm text-center w-50"
                      id="sueldo1" v-model="sueldoFinal" /> -->
              <!-- <label  class="mb-0 fw-semibold">
                      {{ itema.renSueldo }}
                    </label>
                  </div>
                </div>
              </td> -->

              <!-- FECHA INICIO -->
              <td class="align-middle text-center">
                <div class="d-flex align-items-center justify-content-center gap-2">
                  <i class="bi bi-calendar-check text-success fs-6"></i>
                  <input type="date" class="form-control form-control-sm text-center tamaño w-auto"
                    @change="FechaIni($event)" disabled :value="itema.fechaIniContrato.slice(0, 10)" />
                </div>
                <!-- :disabled="!itema.renAccionReg" -->
              </td>

              <!-- FECHA FIN -->
              <td v-if="!esMasivo" class="align-middle text-center">
                <div class="d-flex align-items-center justify-content-center gap-2">
                  <i class="bi bi-calendar-x text-danger fs-6"></i>
                  <input type="date" class="form-control form-control-sm text-center tamaño w-auto"
                    @change="FechaFin($event)" :disabled="!itema.renAccionReg"
                    :value="itema.fechaFinContrato.slice(0, 10)" />
                </div>
              </td>

              <!-- MOTIVO -->
              <td v-if="!esMasivo" class="align-middle text-center">
                <div class="d-flex flex-column align-items-center">
                  <!-- <i class="bi bi-clipboard-check text-warning fs-6 mb-1"></i> -->
                  <div v-if="itema.renAccionReg" class="w-100">
                    <select @change="Motivos($event)" class="form-select form-select-sm tamaño text-center" required>
                      <option disabled selected>-- MOTIVO --</option>
                      <option v-for="motivos in motivo" :key="motivos.id" :value="motivos.parCorrelativo">
                        {{ motivos.parDescripcion }}
                      </option>
                    </select>
                  </div>

                  <div v-else>
                    <i class="bi bi-clipboard-check text-secondary fs-6 mb-1"></i>
                    <p class="mb-0 fw-semibold" v-if="itema.motivoRenovacion.length > 0">
                      {{ itema.motivoRenovacion }}
                    </p>
                    <p class="mb-0 text-muted" v-else>-</p>
                  </div>
                </div>
              </td>

              <!-- DÍAS PARA RENOVAR -->
              <td class="align-middle text-center">
                <div class="d-flex align-items-center justify-content-center gap-2">
                  <i class="bi bi-hourglass-split text-info fs-6"></i>
                  <span class="fw-semibold">En {{ itema.diasRen }} días</span>
                </div>
              </td>

              <!-- DÍAS TRABAJADOS -->
              <!-- <td class="align-middle text-center">
                <div class="d-flex align-items-center justify-content-center gap-2">
                  <i class="bi bi-calendar-check text-success fs-6"></i>
                  <span class="fw-semibold">{{ itema.diasTrabajador }}</span>
                </div>
              </td> -->

              <!-- AÑOS / MESES / DÍAS -->
              <td class="align-middle text-center">
                <div
                  class="form-group w-100 d-flex align-items-center justify-content-center flex-wrap gap-2 text-break">
                  <!-- AÑOS -->
                  <p class="mb-0 fw-bold d-flex align-items-center text-nowrap"
                    v-if="itema.formatoAño.slice(0, 1) == 1">
                    <i class="bi bi-hourglass-split text-primary fs-6 me-1"></i>
                    {{ itema.formatoAño }} año
                  </p>
                  <p class="mb-0 fw-bold d-flex align-items-center text-nowrap" v-if="
                    itema.formatoAño.slice(0, 1) != 0 &&
                    itema.formatoAño.slice(0, 1) != 1
                  ">
                    <i class="bi bi-hourglass-split text-primary fs-6 me-1"></i>
                    {{ itema.formatoAño }} años
                  </p>

                  <!-- MESES -->
                  <p class="mb-0 fw-bold d-flex align-items-center text-nowrap"
                    v-if="itema.formatoMes.slice(0, 1) == 1">
                    <i class="bi bi-calendar3 text-danger fs-6 me-1"></i>
                    {{ itema.formatoMes }} mes
                  </p>
                  <p class="mb-0 fw-bold d-flex align-items-center text-nowrap" v-if="
                    itema.formatoMes.slice(0, 1) != 1 &&
                    itema.formatoMes.slice(0, 1) != 0
                  ">
                    <i class="bi bi-calendar3 text-danger fs-6 me-1"></i>
                    {{ itema.formatoMes }} meses
                  </p>

                  <!-- DÍAS -->
                  <p class="mb-0 fw-bold d-flex align-items-center text-nowrap"
                    v-if="itema.formatoDias.slice(0, 1) == 1">
                    <i class="bi bi-clock-history text-success fs-6 me-1"></i>
                    {{ itema.formatoDias }} día
                  </p>
                  <p class="mb-0 fw-bold d-flex align-items-center text-nowrap" v-if="
                    itema.formatoDias.slice(0, 1) != 1 &&
                    itema.formatoDias.slice(0, 1) != 0
                  ">
                    <i class="bi bi-clock-history text-success fs-6 me-1"></i>
                    {{ itema.formatoDias }} días
                  </p>
                </div>
              </td>

              <!-- BOTONES DE ACCIÓN -->
              <td class="align-middle text-center">
                <div class="d-flex justify-content-center align-items-center flex-wrap gap-2">
                  <button v-if="!esMasivo"
                    :disabled="from.idRenovacion == itema.idRenovacion || itema.renAccionReg == true ? false : true"
                    @click="Registro(itema)"
                    class="btn btn-outline-success btn-sm rounded-3 d-flex align-items-center justify-content-center px-2 py-1"
                    title="Registrar renovación">
                    <i class="bi bi-check-circle-fill fs-5"></i>
                  </button>

                  <button @click="Eliminar(itema.idRenovacion)"
                    :disabled="from.idRenovacion == itema.idRenovacion || itema.renAccionReg == true ? false : true"
                    class="btn btn-outline-danger btn-sm rounded-3 d-flex align-items-center justify-content-center px-2 py-1"
                    title="Eliminar renovación">
                    <i class="bi bi-trash3 fs-5"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table v-if="segundaTabla" class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-center text-white text-nowrap">
              <th colspan="7">DATOS GENERALES</th>
              <th colspan="4">RENOVACION</th>
              <th colspan="4">HISTORIAL</th>
            </tr>
            <tr class="bg-solimano text-center text-white text-nowrap">
              <th class="px-0 mx-0" scope="col"></th>
              <th scope="col">PERIODO</th>
              <th scope="col">CIUDAD</th>
              <th scope="col">TRABAJADOR</th>
              <th scope="col">CLIENTE</th>
              <th scope="col">PUESTO</th>
              <th scope="col">CONTRATO ACTUAL</th>
              <th scope="col">SUELDO</th>
              <th scope="col">FECHA INICIO</th>
              <th scope="col">FECHA FIN</th>
              <th scope="col">MOTIVO</th>
              <th scope="col">VCTO. DE CONTRATO</th>
              <th scope="col">DIAS TRABAJADOR</th>
              <th scope="col">RECORD TRABAJADORES</th>

              <th scope="col"><i class="bi bi-boxes"></i></th>
            </tr>
          </thead>
          <tbody class="align-middle">
            <tr class="ext-center align-middle reducirTamaño" v-for="(itema, index) in itemsPaginados" :key="index">
              <th class="px-2" scope="row">
                <div class="">
                  <input @change="actualizarEstado(itema)" :disabled="isdisabled2" type="checkbox"
                    :value="itema.idRenovacion" v-model="itema.renAccionReg" />
                </div>
              </th>

              <td class="text-start fw-bold">
                <label>{{ itema.periodo }}</label><br>
                <label for="" :class="{
                  'text-primary': itema.renCodEstado == 'EN PROCESO',
                  'text-warning': itema.renCodEstado == 'SOLICITADO',
                  'text-danger': itema.renCodEstado == 'NO RENOVADO',
                }">{{ itema.renCodEstado }}</label>
              </td>


              <td class="">{{ itema.departamento }}</td>

              <td class="text-start fw-bold">
                <label class="">{{ itema.nroDocumento }}</label>
                <label for="" class="px-2">{{ itema.nomTrabajador }}</label>
              </td>


              <td class="text-start">
                <!-- <select
                        @change="SubSubCentroCostosManda($event)"
                        v-if="itema.accionRen"
                        class="form-control text-center"
                        id="exampleFormControlSelect1"
                        disabled
                        >
                        <option disabled selected>
                            {{ itema.subSubCentroCostos }}
                        </option>
                        <option
                            v-for="subSubCentro in SubSubCentroCosto"
                            :key="subSubCentro.id"
                            :value="subSubCentro.cenSubSubCodigo"
                        >
                            {{ subSubCentro.cenNombre }}
                        </option>
                        </select> -->
                <label class="">{{ itema.nomEmpresa }}</label> <br>
                <label class="">{{ itema.subCentroCostos }}</label> <br>
                <label class=""> {{ itema.subSubCentroCostos }}</label>
              </td>

              <td>
                <select @change="Puesto($event.target.selectedIndex)" v-if="itema.renAccionReg"
                  class="form-control reducirTamaño" id="exampleFormControlSelect1">
                  <option disabled selected>{{ itema.nomPuesto }}</option>
                  <option v-for="puestos in puesto" :key="puestos.id">
                    {{ puestos.ptoNombre }}
                  </option>
                </select>

                <label for="" v-else class="">{{ itema.nomPuesto }}</label>
              </td>


              <td class="px-0 mx-0">
                <label v-if="itema.fecIniConActual.slice(0, 10) == '1900-01-01'" disabled class="text-center">
                  -
                </label>

                <label v-else disabled class="border-0 text-center" type="date">
                  {{ new Date(itema.fecIniConActual).toLocaleDateString('es-ES') }} - {{ new
                    Date(itema.fecFinConActual).toLocaleDateString('es-ES') }} </label><br>
                <label>SUELDO ACTUAL: {{ itema.renSueldoActual }}</label>
              </td>



              <td class="">
                <div class="form-group">
                  <!-- <p >{{ puesto[index].rangoSueldo }}</p> -->

                  <p v-if="
                    sueldoFinal >
                    itema.renSueldoActual * (sueldoCargo / 100) +
                    itema.renSueldoActual &&
                    from.idRenovacion == itema.idRenovacion
                  ">
                    No puedes exceder el 20% del sueldo Actual
                    {{
                      (
                        parseFloat(
                          parseFloat(itema.renSueldoActual) *
                          parseFloat(sueldoCargo)
                        ) /
                        100 +
                        parseFloat(itema.renSueldoActual)
                      ).toFixed(2)
                    }}
                  </p>

                  <input v-if="itema.accionRen" type="text" class="text-center" id="sueldo1" v-model="sueldoFinal" />

                  <!-- @change="mostrar($event)"
                        :value="data.item.renSueldo" -->

                  <label for="" class="" v-if="!itema.accionRen">{{
                    itema.renSueldo
                  }}</label>
                </div>
              </td>

              <td>
                <input v-if="itema.accionRen" disabled class="border-0 text-center" @change="FechaIni($event)"
                  type="date" :value="itema.fechaIniContrato.slice(0, 10)" />
                <input v-if="!itema.accionRen" class="border-0 text-center" disabled @change="FechaIni($event)"
                  type="date" :value="itema.fechaIniContrato.slice(0, 10)" />
              </td>

              <td>
                <input v-if="itema.accionRen" class="border-1 text-center" @change="FechaFin($event)" type="date"
                  :value="itema.fechaFinContrato.slice(0, 10)" />
                <input v-if="!itema.accionRen" disabled class="border-1 text-center" @change="FechaFin($event)"
                  type="date" :value="itema.fechaFinContrato.slice(0, 10)" />
              </td>

              <td>
                <select @change="Motivos($event)" v-if="itema.accionRen" class="form-control reducirTamaño"
                  id="exampleFormControlSelect1" required>
                  <option disabled selected>-- SELECCIONAR MOTIVO --</option>
                  <option v-for="motivos in motivo" :key="motivos.id" :value="motivos.parCorrelativo">
                    {{ motivos.parDescripcion }}
                  </option>
                </select>

                <div class="" for="" v-else>
                  <p class="mb-0" v-if="itema.motivoRenovacion.length > 0">
                    {{ itema.motivoRenovacion }}
                  </p>
                  <p class="mb-0" v-else>-</p>
                </div>
              </td>

              <td class="text-center">
                <div class="text-start fw-bold">
                  <label for="" class="text-center">En {{ itema.diasRen }} Días</label>
                </div>
              </td>

              <td class="text-center fw-bold">{{ itema.diasTrabajador }}</td>

              <td class="align-middle text-center">
                <div class="form-group w-auto d-flex align-items-center">
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoAño.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoAño.slice(0, 1) == 1">
                    {{ itema.formatoAño }} año
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoAño.slice(0, 1) != 1 &&
                    itema.formatoAño.slice(0, 1) != 0
                  ">
                    {{ itema.formatoAño }} años
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoMes.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoMes.slice(0, 1) == 1">
                    {{ itema.formatoMes }} mes
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoMes.slice(0, 1) != 1 &&
                    itema.formatoMes.slice(0, 1) != 0
                  ">
                    {{ itema.formatoMes }} meses
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoDias.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoDias.slice(0, 1) == 1">
                    {{ itema.formatoDias }} días
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoDias.slice(0, 1) != 1 &&
                    itema.formatoDias.slice(0, 1) != 0
                  ">
                    {{ itema.formatoDias }} días
                  </p>
                </div>
              </td>


              <td class="px-0 py-0 my-0">
                <div class="form-group">
                  <button :disabled="from.idRenovacion == itema.idRenovacion ||
                    itema.accionRen == true
                    ? false
                    : true
                    " @click="Registro(itema)" class="btn btn-light py-1 my-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                      class="bi bi-check-circle text-success" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                    </svg>
                  </button>

                  <button @click="Eliminar(itema.idRenovacion)" :disabled="from.idRenovacion == itema.idRenovacion ||
                    itema.accionRen == true
                    ? false
                    : true
                    " class="btn btn-light text-danger py-0 my-0">
                    <i class="bi bi-trash3 fs-5"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
      <!-- Ir al inicio -->
      <button class="btn btn-outline-primary btn-sm" @click="irInicio" :disabled="pag === 1">
        <i class="bi bi-chevron-double-left"></i>
      </button>

      <!-- Retroceder -->
      <button class="btn btn-outline-primary btn-sm" @click="retroceso" :disabled="noRetroceder || pag === 1">
        <i class="bi bi-chevron-left"></i>
      </button>

      <!-- Info de página -->
      <span class="pagination-info small px-2">
        Página {{ pag }} de {{ totalPaginas }}
      </span>

      <!-- Avanzar -->
      <button class="btn btn-outline-primary btn-sm" @click="aumentar" :disabled="noAvanzar || pag === totalPaginas">
        <i class="bi bi-chevron-right"></i>
      </button>

      <!-- Ir al final -->
      <button class="btn btn-outline-primary btn-sm" @click="irFinal" :disabled="pag === totalPaginas">
        <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
export default {
  name: 'SolimanologRegistroRenova',

  data() {
    return {
      mensajeNumero: "",
      idRenovacion: "",
      checkeId: [],
      Dni: "",
      Apellidos: "",
      SubSubCentro: "",
      documentos: [],
      primeraTabla: true,
      segundaTabla: false,
      terceraTabla: false,
      excelCarga: false,
      excel: [],

      idTrabajador: "",

      from: {
        idRenovacion: "",
      },

      motivo: [],
      masisvo: [],
      CentroCosto: [],
      SubCentroCosto: [],
      SubSubCentroCosto: [],
      puesto: [],
      dniUsuario: "",
      idEmpresa: "",
      cenCodigoCentro: "",
      cenCodigoSubCentro: "",
      cenCodigoSubSubCemtro: "",
      codRenMotivo: "",
      fechaIni: "1900-01-01",
      fechaFin: "1900-01-01",
      idPuesto: "0",
      sueldo: 0,
      sueldoFinal: 0,
      sueldoCargo: 0,

      isdisabled: false,
      isdisabled2: false,

      Ciudad: "",

      pag: 1,
      NUM_RESULTS: 15,
      NUM_RESULTS1: 15,
      retroceder: "<<",
      avanzar: ">>",
      perPage: 15, // Número de resultados por página
      noAvanzar: false,
      noRetroceder: false,
      perAno: "0",
      perMes: "0",
      codRenMotivoMasivo: "",
      fechaFinMasivo: "1900-01-01",
    };
  },

  mounted() {
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");

    this.axios.get("ParametroData/Parametro/7634").then((r) => {
      console.log(r.data);
      this.motivo = r.data;
    });

    this.axios.get("PuestoData/ListadoPuesto").then((r) => {
      console.log(r.data);
      this.puesto = r.data;
    });

    console.log(this.Items.length);
    this.totalRows = this.Items.length;
  },

  created() {
    this.Renovaciones();
    this.reporteRenovacion();
    this.cambiarEstadoNavbar()
    this.CargaTrabajadores();
  },

  computed: {
    ...mapGetters("users", ["DniEmpre"]),
    ...mapGetters("renovaciones", ["Items"]),


    itemsFiltrados() {
      return this.Items.filter(item => {
        const dni = this.Dni.toLowerCase();
        const apellidos = this.Apellidos.toLowerCase();
        const ciudad = this.Ciudad.toLowerCase();
        const subCentro = this.SubSubCentro.toLowerCase();
        const periodo = (this.perAno !== "0" && this.perMes !== "0") ? `${this.perAno}${this.perMes}` : "";

        return (
          (!dni || item.nroDocumento?.toLowerCase().includes(dni)) &&
          (!apellidos || item.nomTrabajador?.toLowerCase().includes(apellidos)) &&
          (!ciudad || item.departamento?.toLowerCase().includes(ciudad)) &&
          (!subCentro || item.subSubCentroCostos?.toLowerCase().includes(subCentro)) &&
          (!periodo || (item.periodo && item.periodo.toString().includes(periodo)))
        );
      });
    },

    itemsPaginados() {
      const inicio = this.NUM_RESULTS - 15;
      return this.itemsFiltrados.slice(inicio, this.NUM_RESULTS);
      // const start = (this.pag - 1) * this.perPage;
      // return this.itemsFiltrados.slice(start, start + this.perPage);
    },

    totalPaginas() {
      return Math.max(1, Math.ceil(this.itemsFiltrados.length / 15));
    },
    seleccionadosMasivo() {
      // Filtra los items que tienen el checkbox marcado (renAccionReg en true)
      return this.Items.filter(item => item.renAccionReg);
    },
    esMasivo() {
      // Devuelve true si hay mas de 1 seleccionado
      return this.seleccionadosMasivo.length > 1;
    },
    resumenGrupos() {
      const conteo = {};
      
      // Recorremos los items filtrados para agrupar
      this.itemsFiltrados.forEach(item => {
        const empresa = item.nomEmpresa ? item.nomEmpresa.replace(/ S\.A\.C\.| S\.A\.| S\.R\.L\./gi, '') : 'Sin Empresa';
        const canal = item.subSubCentroCostos || 'Sin Canal';
        const llave = `${empresa} - ${canal}`;
        
        if (!conteo[llave]) {
          conteo[llave] = 0;
        }
        conteo[llave]++;
      });

      // Convertimos el objeto a un array para poder mostrarlo en el v-for
      return Object.entries(conteo)
        .map(([nombre, cantidad]) => ({ nombre, cantidad }))
        .sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
    cantidadMayor5Anios() {
      return this.itemsFiltrados.filter(item => {
        const anios = parseInt(item.formatoAño) || 0;
        return anios >= 5;
      }).length;
    }
  },
  watch: {
    Dni() { this.resetPagina(); },
    Apellidos() { this.resetPagina(); },
    Ciudad() { this.resetPagina(); },
    SubSubCentro() { this.resetPagina(); },
    perAno() { this.resetPagina(); },
    perMes() { this.resetPagina(); },
    // esMasivo(val) {
    //   // Si se activa el modo masivo, manda el scroll arriba
    //   if (val) window.scrollTo({ top: 0, behavior: 'smooth' });
    // },
  },

  methods: {
    ...mapActions("renovaciones", ["Renovaciones"]),

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

   

    MarcarTodos() {
      // 1. Verificamos si todos ya están marcados
      const todosMarcados = this.itemsFiltrados.every(item => item.renAccionReg == true);

      // 2. Si todos están marcados, la acción es desmarcar (0), de lo contrario marcar (1)
      const nuevaAccion = todosMarcados ? "0" : "1";

      // 3. Obtenemos los IDs
      const ids = this.itemsFiltrados.map(item => item.idRenovacion).join(',');

      if (!ids) return;

      // Mostramos spinner de carga
      Swal.fire({
        title: 'Procesando',
        text: 'Por favor espere mientras se actualiza la selección...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const data = {
        idRenovaciones: ids,
        accion: nuevaAccion
      };

      this.axios.put("Renovacion/CambioEstadoGeneral", data)
        .then(res => {
          if (res.data) {
            // 4. Actualizamos la vista localmente para que los checks cambien
            this.itemsFiltrados.forEach(item => {
              item.renAccionReg = (nuevaAccion === "1");
            });
            
            // Alerta de éxito según la acción realizada
            Swal.fire({
              title: nuevaAccion === "1" ? '¡Seleccionado!' : '¡Desmarcado!',
              text: nuevaAccion === "1" ? 'Se han seleccionado todos los registros.' : 'Se han desmarcado todos los registros.',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            });
          }
        })
        .catch(err => {
          console.error(err);
          Swal.fire('Error', 'Ocurrió un problema al procesar la solicitud.', 'error');
        });
    },

    resetPagina() {
      this.pag = 1;
      this.NUM_RESULTS = 15;
      this.noRetroceder = true;
      this.noAvanzar = this.itemsFiltrados.length <= 15;
    },
    Eliminar(id) {
      this.axios.delete(`Renovacion/EliminarRenovacion?idRenovacion=${id}`).then(r => {
        console.log(r.data)
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.Renovaciones()

      })
    },
    reporteRenovacion() {
      console.log("aja");
      this.idTrabajador = localStorage.getItem("idTrabajdor");

      this.excelCarga = false;
      this.axios
        .get(
          `ReportesExcel/RepRenovacioness?idTrabajador=${this.idTrabajador}`,
          { responseType: "blob" }
        )
        .then((response) => {
          this.excelCarga = true;
          this.excel = response.data;
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    descargarExcel() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excel]));
      var fileLink = document.createElement("a");
      const fecha = new Date();
      const dia = String(fecha.getDate()).padStart(2, '0');
      const mes = String(fecha.getMonth() + 1).padStart(2, '0');
      const anio = fecha.getFullYear();

      fileLink.href = fileURL;
      fileLink.setAttribute("download", `ReporteRenovaciones-${dia}-${mes}-${anio}.xlsx`);
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    fetchItems() {
      console.log(this.Dni.length);

      if (this.Dni.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.documentos = [];
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxDni`, {
            params: {
              NroDocumento: this.Dni,
              idTrabajador: this.idTrabajador,
              perAno: this.perAno,
              perMes: this.perMes,
              codEstado: '001',
              opcion: 1
            },
          }
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }

            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    fetchApellido() {
      console.log(this.Apellidos.length);

      if (this.Apellidos.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.documentos = [];
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxApellido`, {
            params: {
              Apellido: this.Apellidos,
              idTrabajador: this.idTrabajador,
              perAno: this.perAno,
              perMes: this.perMes,
              codEstado: '001',
              opcion: 1
            },
          }
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    fetchSubSubCentro() {
      this.documentos = [];
      if (this.SubSubCentro.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.documentos = [];
        this.Renovaciones();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxSubSubCc`, {
            params: {
              cuenta: this.SubSubCentro,
              idTrabajador: this.idTrabajador,
              perAno: 0,
              perMes: 0,
              codEstado: '001',
              opcion: 1
            },
          }
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    fetchCiudad() {
      this.documentos = [];
      if (this.Ciudad.length == 0) {
        this.primeraTabla = true;
        this.documentos = [];
        this.segundaTabla = false;
        // this.terceraTabla = false;
        this.Renovaciones();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxDepa`, {
            params: {
              departamento: this.Ciudad,
              idTrabajador: this.idTrabajador,
              perAno: 0,
              perMes: 0,
              codEstado: '001'
            },
          }
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              // this.segundaTabla = false;
              // this.terceraTabla = true;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    CargaTrabajadores() {
      const usuario = localStorage.getItem("userId");
      this.axios
        .get(`Renovacion/CanTrabajadores?idUsuario=${usuario}`)
        .then((r) => {
          if (r.status == 200) {
            this.reporteRenovacion();
            if (r.data.canTrabajadores == "0") {
              Swal.fire(`NO SE CARGÓ NINGÚN TRABAJADOR`, "", "success");
            } else if (r.data.canTrabajadores == "1") {
              Swal.fire(
                `SE REGISTRÓ ${r.data.canTrabajadores}  TRABAJADOR`,
                "",
                "success"
              );
            } else {
              Swal.fire(
                `SE REGISTRARON ${r.data.canTrabajadores}  TRABAJADORES`,
                "",
                "success"
              );
            }
          }

          // Limpiamos los filtros para que se actualicen los cuadros resumen con la nueva data completa
          this.Dni = "";
          this.Apellidos = "";
          this.SubSubCentro = "";
          this.Ciudad = "";
          this.resetPagina();

          this.Renovaciones();
        });
    },

    Indi() {
      this.masivo = false;
      this.isdisabled2 = false;

    },

    Motivos(event) {
      this.codRenMotivo = event.target.value;
    },

    SubSubCentroCostosManda(event) {
      this.cenCodigoSubSubCemtro = event.target.value;
      console.log(event.target.value);
    },

    Puesto(index) {
      const puestos = this.puesto[index - 1];
      this.idPuesto = puestos.idPuesto;
      this.sueldoCargo = puestos.rangoSueldo;

      console.log(puestos);
    },

    FechaIni(event) {
      this.fechaIni = event.target.value;
      console.log(event.target.value);
    },

    FechaFin(event) {
      this.fechaFin = event.target.value;
    },
    Registro(items) {
      console.log(items);

      if (this.fechaIni == "1900-01-01" && this.fechaFin == "1900-01-01") {
        const form = {
          idRenovacion: items.idRenovacion,
          idrenResponsable: this.idTrabajador,
          renCodCC: items.renCodCC,
          renCodScc: items.renCodScc,
          renCodSscc: items.renCodSscc,
          idPuestoNuevo: this.idPuesto,
          renSueldo: this.sueldoFinal,
          codRenMotivo: this.codRenMotivo,
          fechaIniContrato: items.fechaIniContrato,
          fechaFinContrato: items.fechaFinContrato,
          idUsuario: localStorage.getItem("userId"),
          EstadoPdf: false,
          AccionRen: false,
          EstadoAdjunto: false,
          // renCodEstado: (this.codRenMotivo == '003') ? '006' : '002'
          renCodEstado: '002'


        };

        console.log(form);

        if (this.sueldoFinal < items.renSueldoActual && this.sueldoFinal != 0) {
          Swal.fire({
            icon: "error",
            title: "El sueldo no puede ser menor al sueldo actual",
            text: "",
          });
        } else {
          this.axios
            .put("Renovacion/ModificarRenovacion", form)
            .then((r) => {
              console.log(r.data);
              if (r.data == true) {
                this.isdisabled2 = false;
                this.primeraTabla = true;
                this.segundaTabla = false;
                this.terceraTabla = false;
                this.Renovaciones();
                Swal.fire("Se registró renovación", "", "success");
              }
            })
            .catch((error) => {
              console.log(error.response.status);
              if (error.response.status == 400) {
                Swal.fire({
                  icon: "error",
                  title: "Falto  el motivo de la renovación",
                  text: "",
                });
              }
            });
        }
      } else {
        const form = {
          idRenovacion: items.idRenovacion,
          idrenResponsable: this.idTrabajador,

          renCodCC: items.renCodCC,
          renCodScc: items.renCodScc,
          renCodSscc: items.renCodSscc,
          idPuestoNuevo: this.idPuesto,
          renSueldo: this.sueldoFinal,
          codRenMotivo: this.codRenMotivo,
          fechaIniContrato: items.fechaIniContrato.slice(0, 10),
          fechaFinContrato: this.fechaFin,
          idUsuario: localStorage.getItem("userId"),
          EstadoPdf: false,
          AccionRen: false,
          EstadoAdjunto: false,
          // renCodEstado: (this.codRenMotivo == '003') ? '006' : '002'
          renCodEstado: '002'

        };
        console.log(form);

        if (this.sueldoFinal < items.renSueldoActual && this.sueldoFinal != 0) {
          Swal.fire({
            icon: "error",
            title: "El sueldo no puede ser menor al sueldo actual",
            text: "",
          });
        } else {
          this.axios
            .put("Renovacion/ModificarRenovacion", form)
            .then((r) => {
              console.log(r.data);
              if (r.data == true) {
                this.isdisabled2 = false;
                this.Renovaciones();
                Swal.fire("Se registró renovación", "", "success");
              }
            })
            .catch((error) => {
              console.log(error.response.status);
              if (error.response.status == 400) {
                Swal.fire({
                  icon: "error",
                  title: "Falto  el motivo de la renovación",
                  text: "",
                });
              }
            });
        }
      }
    },

    actualizarEstado(items) {
      console.log(items);
      this.from.idRenovacion = items.idRenovacion;

      for (let index of this.Items) {
        if (index.idRenovacion == items.idRenovacion) {
          console.log(index.idEmpresa, index.renCodCC, index.renCodScc);
          this.axios
            .get(
              `SubSubCentro/SScxTrabajador?idEmpresa=${index.idEmpresa}&dniUser=${this.dniUsuario}&codCentro=${index.renCodCC}&codSubCentro=${index.renCodScc}`
            )
            .then((r) => {
              this.SubSubCentroCosto = r.data;
              console.log(r.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      if (items.accionRen == true) {
        this.isdisabled2 = true;
        this.colorRenovacion = items.idRenovacion;
      } else {
        this.colorRenovacion = "";
      }

      this.axios.put("Renovacion/ModificarAccionxRenReg", this.from).then((r) => {
        console.log(r);
      });
    },

    async registrarMasivo() {
      if (!this.fechaFinMasivo || !this.codRenMotivoMasivo) {
        Swal.fire("Atención", "Complete todos los campos para el registro masivo (Fechas y Motivo)", "warning");
        return;
      }

      Swal.fire({
        title: 'Registrando...',
        text: 'Por favor espere mientras se procesan los registros',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      try {
        const promises = this.seleccionadosMasivo.map(item => {
          const form = {
            idRenovacion: item.idRenovacion,
            idrenResponsable: this.idTrabajador,
            renCodCC: item.renCodCC,
            renCodScc: item.renCodScc,
            renCodSscc: item.renCodSscc,
            // Mantenemos el puesto y sueldo actual ya que en masivo solo cambiamos fechas y motivo
            idPuestoNuevo: item.idPuestoNuevo || item.idPuesto || "0",
            renSueldo: item.renSueldoActual,
            codRenMotivo: this.codRenMotivoMasivo,
            fechaFinContrato: this.fechaFinMasivo,
            idUsuario: localStorage.getItem("userId"),
            EstadoPdf: false,
            AccionRen: item.renAccionReg, // Usamos renAccionReg
            EstadoAdjunto: false,
            renCodEstado: "003" // Estado Terminado/Renovado
          };
          return this.axios.put("Renovacion/ModificarRenovacion", form);
        });

        await Promise.all(promises);

        Swal.fire("Éxito", "Registros masivos actualizados correctamente", "success");
        this.fechaIniMasivo = "";
        this.fechaFinMasivo = "";
        this.codRenMotivoMasivo = "";
        this.GestionRenovacion();

      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Hubo un problema al actualizar algunos registros", "error");
      }
    },

    CargaMasiva() {
      // 1. Filtramos los items que tienen el check marcado (renAccionReg == true)
      const seleccionados = this.Items.filter(item => item.renAccionReg);

      // 2. Extraemos los IDs y creamos la cadena separada por comas (ej: "10,11,12")
      const cadenaIds = seleccionados.map(item => item.idRenovacion).join(',');

      // Validaciones previas
      if (!cadenaIds) {
        Swal.fire("Atención", "No has seleccionado ningún trabajador para renovar.", "warning");
        return;
      }

      if (!this.fechaFinMasivo || this.fechaFinMasivo === '1900-01-01' || !this.codRenMotivoMasivo) {
        Swal.fire("Atención", "Por favor ingresa la Fecha Fin y el Motivo para la carga masiva.", "warning");
        return;
      }

      const from = {
        cadenaRenovacion: cadenaIds,
        fechaFinContrato: this.fechaFinMasivo,
        codRenMotivo: this.codRenMotivoMasivo,
        idUsuario: localStorage.getItem("userId"),
      };
      console.log("Enviando Carga Masiva:", from);

      this.axios.put("Renovacion/ModificarRenMasivo", from).then((r) => {
        console.log(r.data);
        if (r.data == true) {
          Swal.fire("Éxito", "Se renovaron los trabajadores correctamente", "success");
          this.Renovaciones(); // Recargamos la tabla

          // Limpiamos los campos del formulario masivo
          this.fechaFinMasivo = "1900-01-01";
          this.codRenMotivoMasivo = "";
        } else {
          Swal.fire("Error", "No se pudo realizar la actualización", "error");
        }
      }).catch(error => {
        console.error(error);
        Swal.fire("Error", "Ocurrió un problema en el servidor", "error");
      });
    },

    retroceso() {
      if (this.NUM_RESULTS === 15) {
        this.noRetroceder = true;
      } else {
        this.NUM_RESULTS -= 15;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
      if (this.pag > 1) {
        this.pag--;
      }
    }

  },

    aumentar() {
      this.NUM_RESULTS += 15;
      this.pag += 1;
      if (this.NUM_RESULTS > 15) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      if (this.pag < this.totalPages) {
        this.pag++;
      }
      if (this.NUM_RESULTS >= this.itemsFiltrados.length) {
        this.noAvanzar = true;
      } else {
        this.noAvanzar = false;
      }

    }
    },

    // Ir a la primera página
    irInicio() {
      this.pag = 1;
      this.NUM_RESULTS = 15;
      this.noRetroceder = true;
      this.noAvanzar = this.itemsFiltrados.length <= 15;
    },

    // Ir a la última página
    irFinal() {
      const totalPages = this.totalPaginas;
      this.pag = totalPages;
      this.NUM_RESULTS = totalPages * 15;
      this.noAvanzar = true;
      this.noRetroceder = false;
    },
  },
};
</script>


<style scoped>
select {
  margin-top: 0px;
  padding: 0px;
}

input[type="date"] {
  padding: 0px;
  height: auto;
}

input[type="text"] {
  min-width: 150px;
  padding: 0px;
}

.text-left {
  text-align: left;
}

select {
  width: auto;
  display: inline-block;

  text-align: center;
}



.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.label-resaltado {
  font-weight: 700;
  font-size: 0.65rem;
}

.tamaño {
  font-size: 0.70rem;

  font-weight: 800;
  color: #002c5d;
}
</style>
